<template>
  <div class="topBar" :style="nextMatchDateTimeMS < 0 ? 'background-color: white;' : ''" :class="$isMobile ? 'topBar--mobile' : ''">
    <CalendarTimer :shrinkedView="shrinkedView" :bookingOrViewing="true" :topBarView="true" />
    <NoBookings v-if="nextMatchDateTimeMS < 0" :topBarView="true" />
  </div>
</template>

<script>
import CalendarTimer from "@/components/Timer/CalendarTimer";
import NoBookings from "./Widgets/NoBookings";

export default {
  name: "TopBar",
  props: ["shrinkedView", "bookingOrViewing", "nextMatchDateTimeMS", "selectedDateTimes"],
  components: {
    CalendarTimer,
    NoBookings,
  },
};
</script>

<style scoped>
.topBar {
  flex-direction: row;
  display: flex;
  padding: 6px 0px;
  font-family: "Nunito", sans-serif;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #eaeaea;
  border-color: transparent;
  border-radius: 360px;
  margin-left: 26px;
  margin-right: 26px;
  margin-bottom: -10px;
  margin-top: 10px;
  justify-content: center;
  background-color: #ffffff8a !important;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 15px rgb(58 58 58 / 10%), 0 9px 24px rgb(213 213 213 / 13%);
}
.topBar--mobile {
  margin-top: 5px;
  margin-bottom: -15px;
}
</style>
